export default [
  {
    path: '/newGift/index',
    meta:{
      title: '新人礼包'
    },
    component: (resolve) => require(['@/pages/newGift/index'], resolve)
  }
]